import { apiClient } from './api-client';

export interface EquipmentType {
  id: string;
  tenantId: string;
  categoryId: string;
  name: string;
  description: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface EquipmentTypeListResponse {
  items: EquipmentType[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateEquipmentTypePayload {
  name: string;
  categoryId: string;
  description?: string;
}
export type UpdateEquipmentTypePayload = Partial<CreateEquipmentTypePayload> & {
  isActive?: boolean;
};

export const equipmentTypeService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
    categoryId?: string;
  }): Promise<EquipmentTypeListResponse> =>
    apiClient.get<EquipmentTypeListResponse>('/equipment-types', { params }).then((r) => r.data),

  create: (payload: CreateEquipmentTypePayload): Promise<EquipmentType> =>
    apiClient.post<EquipmentType>('/equipment-types', payload).then((r) => r.data),

  update: (id: string, payload: UpdateEquipmentTypePayload): Promise<EquipmentType> =>
    apiClient.patch<EquipmentType>(`/equipment-types/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/equipment-types/${id}`).then(() => undefined),
};
